module.exports = "mutation BulkDeleteCards($cards: [ID!]!) {\n  bulkDeleteCards(cards: $cards) {\n    successful\n    failedCount\n  }\n}\n"